<!-- image -->
<div class="bg-black">
  <figure *ngIf="contextService.image">
    <img [src]="contextService.image" alt={{contextService.alt}}>
  </figure>
  
  <!-- header -->
  <div *ngIf="displayHeader" class="header">
    <h1>{{contextService.title | translate}}</h1>
    <h4 *ngIf="contextService.subtitle" class="font-weight-normal">{{contextService.subtitle | translate}}</h4>
  </div>
</div>